import { OptionSet } from 'src/tabs/models/SkillsInterfaces';

export const filterCategoriesByKeyWord = (
  categories: OptionSet[],
  keyWord: string
) => {
  return categories.filter((category) =>
    category.label.toLowerCase().includes(keyWord.toLowerCase())
  );
};

export const getCategoryValue = (
  categories: OptionSet[],
  selectedCategory?: string,
  selectedCategoryValue?: string
) => {
  if (+selectedCategory) return selectedCategory;
  const categoryValue = categories.find((category) =>
    !selectedCategoryValue
      ? category.label === selectedCategory
      : category.value === selectedCategoryValue
  )?.value;

  return categoryValue;
};

export const getCategoryName = (
  categories: OptionSet[],
  selectedCategoryValue?: string
) => {
  const categoryName = categories.find(
    (category) => category.value === selectedCategoryValue
  )?.label;

  return categoryName;
};
